import { captureStack1fzi4aczwc4hg as captureStack } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlinx_io_IOException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.s4h_1);
}
var IOExceptionClass;
function IOException() {
  if (IOExceptionClass === VOID) {
    class $ extends Exception() {
      static t4h() {
        var $this = this.ce();
        init_kotlinx_io_IOException($this);
        return $this;
      }
      static u4h(message) {
        var $this = this.de(message);
        init_kotlinx_io_IOException($this);
        return $this;
      }
      static v4h(message, cause) {
        var $this = this.ee(message, cause);
        init_kotlinx_io_IOException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'IOException', $.t4h);
    IOExceptionClass = $;
  }
  return IOExceptionClass;
}
function init_kotlinx_io_EOFException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.y4e_1);
}
var EOFExceptionClass;
function EOFException() {
  if (EOFExceptionClass === VOID) {
    class $ extends IOException() {
      static w4h() {
        var $this = this.t4h();
        init_kotlinx_io_EOFException($this);
        return $this;
      }
      static z4e(message) {
        var $this = this.u4h(message);
        init_kotlinx_io_EOFException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'EOFException', $.w4h);
    EOFExceptionClass = $;
  }
  return EOFExceptionClass;
}
//region block: exports
export {
  EOFException as EOFExceptionh831u25jcq9n,
  IOException as IOException1wyutdmfe71nu,
};
//endregion

//# sourceMappingURL=-PlatformJs.mjs.map
